import { render, staticRenderFns } from "./AllCandidates.vue?vue&type=template&id=56c2e629&scoped=true&"
import script from "./AllCandidates.vue?vue&type=script&lang=ts&"
export * from "./AllCandidates.vue?vue&type=script&lang=ts&"
import style0 from "./AllCandidates.vue?vue&type=style&index=0&id=56c2e629&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c2e629",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VPagination,VRow,VSkeletonLoader})
